import Cookie from 'js-cookie';
import EventBus from 'frontend-resources/plugins/EventBus';

export default ({ store, redirect, route, app: { $axios, $sentry } }) => {
    createAxiosInterceptor('response');
    createAxiosInterceptor('request');
    setUser(store);

    let isRefreshing = false;
    let refreshSubscribers = [];

    $axios.logout = logout;

    function createAxiosInterceptor(type) {
        setUser(store);

        if ($sentry !== undefined && store.user) {
            $sentry.configureScope((scope) => {
                scope.setUser({ username: store.user.email });
            });
        }

        const interceptor = $axios.interceptors[type].use(
            config => {
                const noAuthHeader = config.noAuthHeader || (config.config || {}).noAuthHeader;
                const ignoreLogout = config.ignoreLogout || (config.config || {}).ignoreLogout;

                if (!noAuthHeader && !config.isAuthenticating) {
                    if (!Cookie.get('token' + getCookieSuffix()) && Cookie.get('refresh_token' + getCookieSuffix())) {
                        const error = new Error('Token needs to be refreshed');
                        error.config = config;
                        error.response = { status: 401, config };
                        return Promise.reject(error);
                    }

                    if (Cookie.get('token' + getCookieSuffix()) !== undefined) {
                        setUser(store);
                        config.headers['Authorization'] = 'Bearer ' + Cookie.get('token' + getCookieSuffix());
                        return config;
                    }
                    if (!ignoreLogout) {
                        logout();
                    }
                }
                return config;
            },
            error => {
                const { config: originalRequest } = error;
                const ignoreLogout = originalRequest ? (originalRequest.ignoreLogout || (originalRequest.config || {}).ignoreLogout) : false;
                // Reject promise if usual error
                if (!error.response ||
                  error.response.status !== 401 ||
                  originalRequest.isAuthenticating ||
                  (originalRequest.data && originalRequest.data.refresh === undefined)
                ) {
                    return Promise.reject(error);
                }

                if (!isRefreshing) {
                    return new Promise((resolve, reject) => {
                        isRefreshing = true;
                        $axios.post('/api/token/refresh', {
                            refresh_token: Cookie.get('refresh_token' + getCookieSuffix()),
                            refresh: true,
                        }, {
                            noAuthHeader: true,
                        }).then(response => {
                            onRefreshed(response.data.token);
                            removeAuthCookies();
                            Cookie.set('token' + getCookieSuffix(), response.data.token, { domain: getCookieDomain() });
                            Cookie.set('refresh_token' + getCookieSuffix(), response.data.refresh_token, { domain: getCookieDomain() });
                            error[type].config.headers['Authorization'] = 'Bearer ' + response.data.token;
                            return resolve($axios(error[type].config));
                        }).catch(error => {
                            removeAuthCookies();
                            if (!ignoreLogout) {
                                logout();
                            }
                            return reject(error);
                        }).finally(interceptor);
                    });
                }

                return new Promise((resolve, reject) => {
                    subscribeTokenRefresh(token => {
                    // replace the expired token and retry
                        originalRequest.headers['Authorization'] = 'Bearer ' + token;
                        resolve($axios(originalRequest));
                    });
                });
            }
        );
    };

    function getCookieDomain() {
        if (window.location.hostname.split('.')[1] !== 'scribbr' &&
          window.location.hostname.split('.')[1] !== 'scribbrdev'
        ) {
            return window.location.hostname;
        }

        // removes sub domain part
        return window.location.hostname.split('.').splice(1).join('.');
    }

    function getCookieSuffix() {
        // no suffix for domains that are not scribbr
        if (window.location.hostname.split('.')[1] !== 'scribbr') {
            return '';
        }

        return '_' + window.location.hostname.split('.')[0];
    }

    function setUser(store) {
        if (!Cookie.get('token' + getCookieSuffix())) {
            store.user = null;
            return;
        }
        let details = parseJwt(Cookie.get('token' + getCookieSuffix()));
        store.user = {
            id: details.id,
            email: details.username,
            links: details.links,
            locale: details.locale,
        };
    }

    function subscribeTokenRefresh(cb) {
        refreshSubscribers.push(cb);
    }

    function onRefreshed(token) {
        refreshSubscribers.map(cb => cb(token));
        isRefreshing = false;
        refreshSubscribers = [];
    }

    function logout() {
        removeAuthCookies();
        window.location.replace('/logout');
    }

    function parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    function removeAuthCookies() {
        // twice to make sure it removes from both high domain and sub domain
        Cookie.remove('token' + getCookieSuffix());
        Cookie.remove('refresh_token' + getCookieSuffix());
        Cookie.remove('token' + getCookieSuffix(), { domain: getCookieDomain(), path: '/' });
        Cookie.remove('refresh_token' + getCookieSuffix(), { domain: getCookieDomain(), path: '/' });
    }

    // remove 'newly_registered'/'newly_registered_sfqa' cookies
    EventBus.$on('removeNewlyRegisteredCookieEvent', () => {
        Cookie.remove('newly_registered', { domain: getCookieDomain(), path: '/' });
        Cookie.remove('newly_registered_sfqa', { domain: getCookieDomain(), path: '/' });
    });
};
